import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
    providedIn: 'root',
})
export class AuthStorageService {

    private memory: Record<string, string> = {};
    private isReady = false;
    private loadPromise: Promise<void> | null = null;

    get ready(): Promise<void> {
        return this.loadFromPreferences();
    }

    get isStorageReady(): boolean {
        return this.isReady;
    }

    getItem(key: string): string | null {
        if (!this.isReady) {
            console.warn(`auth storage layer not ready — getItem("${key}") may return null`);
        }
        return this.memory[key] ?? null;
    }

    setItem(key: string, value: string): void {
        this.memory[key] = value;
        Preferences.set({ key, value }).catch(err =>


            console.error('Failed to persist token to Preferences:', err)
        );
    }


    removeItem(key: string): void {
        delete this.memory[key];
        Preferences.remove({ key }).catch(err =>
            console.error('Failed to remove token from Preferences:', err)
        );

    }

    private async loadFromPreferences(): Promise<void> {
        // Prevent multiple simultaneous loads
        if (this.loadPromise) {
            return this.loadPromise;
        }

        if (this.isReady) return;

        this.loadPromise = (async () => {
            try {
                const keys = await Preferences.keys();
                for (const key of keys.keys) {
                    const result = await Preferences.get({ key });
                    if (result.value !== null) {
                        this.memory[key] = result.value;
                    }
                }
                this.isReady = true;
            } catch (err) {
                console.error('[AuthStorage] Failed to load tokens from Preferences:', err);
                throw err;
            } finally {
                this.loadPromise = null;
            }
        })();

        return this.loadPromise;
    }

    // clear()
    async clear(): Promise<void> {
        this.memory = {};
        await Preferences.clear().catch(err =>
            console.error('Failed to clear tokens from Preferences:', err)
        );
    }

}

export enum AuthStorageKeys {
    // Capacitor
    // Capacitor_DeepLinkPath = 'deepLinkPath',
    // Capacitor_backgroundTimestamp = 'lastBackgroundTimestamp',
    // Capacitor_stateChangeIsInitialized = 'stateChangeIsInitialized',

    // OKTA
    Okta_CacheStorage = 'okta-cache-storage',
    Okta_LoginType = 'okta_loginType',
    Okta_accessToken = 'accessToken',
    Okta_refreshToken = 'refreshToken',

    // Set on logout, cleared on the next completed login. Survives the post-logout reload. While set,
    // the cold-start/resume Keychain (iOS) and native-storage (Android) syncs refuse to restore a
    // session — this stops a logged-out session from being resurrected on the next cold start.
    Okta_LoggedOut = 'okta-logged-out',

}













































